"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function buildQueryParameters(params) {
    var queryStr = Object.keys(params)
        .map(function (key) {
        return params[key] && params[key].length > 0
            ? "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(params[key]))
            : '';
    })
        .join('&');
    return "?".concat(queryStr);
}
exports.default = buildQueryParameters;
